/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useRef, useImperativeHandle, forwardRef } from 'react';
import {
  Box,
  CardMedia,
} from '@mui/material';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import { getPageStyle } from '../../../../../components/vizzle/page/common/LessonPageUtil';
import TextLines from '../../../../../components/vizzle/text/TextLines';
import MediaPlayer from '../../../../../components/vizzle/media/MediaPlayer';
import { useTtsPlay } from '../../../utils/UseTtsPlay';
import './SortingActivityPrompt.scss';
import { useRegisterSwitchAccessSelectEvent } from '../../../../switch-access/SwitchAccessHooks';

const SortingActivityPrompt = forwardRef(({
  promptCard,
  promptCardId,
  isRightAlignLayout,
  switchAccessibility,
  children,
  onResponseCardsAreaClick,
  onPromptSwitchAccessSelected,
} = {
  promptCard: {},
  isRightAlignLayout: false,
  switchAccessibility: false,
  children: null,
  onResponseCardsAreaClick: () => { },
  onPromptSwitchAccessSelected: () => { },
}, ref) => {
  const {
    ttsConfig,
    setTextLineRef,
    elementToPlayTts,
  } = useTtsPlay();

  const prompRef = useRef(null);
  const dropZoneRef = useRef(null);
  const switchTargetRef = switchAccessibility ? dropZoneRef : prompRef;
  useImperativeHandle(ref, () => ({
    getEnableElements: () => switchTargetRef.current,
  }));

  useRegisterSwitchAccessSelectEvent(switchTargetRef, () => {
    onPromptSwitchAccessSelected();
  });

  return (
    <Box
      key={promptCardId}
      id={promptCardId}
      boxShadow={2}
      className={`sorting-activity-prompt-card ${isRightAlignLayout ? 'reverse-layout' : ''}`}
      style={getPageStyle(promptCard, true)}
      data-skip-switch-access-click='true'
      ref={prompRef}
    >
      <MediaPlayer
        className='media-action'
        audioUrl={promptCard.audio}
        videoUrl={promptCard.video}
        parentElementId={promptCardId}
        omitPlayIcon
        textToRead={elementToPlayTts}
        tts={ttsConfig}
      />
      <div className='prompt-details'>
        {promptCard.audio || promptCard.video || (elementToPlayTts && elementToPlayTts.length > 0) ? (
          <PlayCircleFilledIcon className='media-player-icon' data-test='media-player-icon' />
        ) : ''}

        {
          promptCard.image ? (
            <div className='prompt-image-container' data-test='prompt-image-container'>
              <CardMedia image={promptCard.image} className='prompt-image' />
            </div>
          ) : ''
        }

        <div className='prompt-text' data-test='prompt-text-container'>
          {promptCard.text ? (
            <TextLines
              textLines={promptCard.text}
              ref={setTextLineRef}
              componentKey={`text-line-${promptCardId}`}
            />
          )
            : ''}
        </div>
      </div>
      <div
        ref={dropZoneRef}
        className='prompt-selected-response-cards'
        data-skip-switch-access-click='true'
        onClick={onResponseCardsAreaClick}
      >
        {children}
      </div>
    </Box>
  );
});

export default SortingActivityPrompt;
